
function convertFileToBase64(file: File) {
	return new Promise<string>((resolve, reject) => {
		const reader = new FileReader();

		reader.readAsDataURL(file);
		reader.onload = () => {
			if (reader.result instanceof ArrayBuffer) {
				resolve(converArrayBufferToString(reader.result));
			} else {
				resolve(reader.result)
			}
		};
		reader.onerror = reject;
	});
}

function converArrayBufferToString(buf: ArrayBuffer): string {
  return String.fromCharCode.apply(null, new Uint16Array(buf));
}

type CompressImageOption = {
	width: number;
	height: number;
	file: File;
	quality?: number;
	scale?: number;
}

function compressImage(options: CompressImageOption) {
	const {
		width,
		height,
		quality = 1,
		scale = 1,
		file,
	} = options;
	return new Promise<File>((resolve, reject) => {
		const fileName = file.name;
		const reader = new FileReader();

		reader.readAsDataURL(file);
		reader.onload = () => {
			const img = new Image();
			if (reader.result instanceof ArrayBuffer) {
				img.src = converArrayBufferToString(reader.result);
			} else {
				img.src = reader.result;
			}
			img.onload = () => {
				const canvas = document.createElement('canvas');
				const scaleWith =  width * scale;
				const scaleHeight =  height * scale;

				canvas.width = scaleWith;
				canvas.height = scaleHeight;

				const ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0, scaleWith, scaleHeight);
				ctx.canvas.toBlob((blob) => {
					const file = new File([blob], fileName, {
						type: 'image/jpeg',
						lastModified: Date.now()
					});
					resolve(file);
				}, 'image/jpeg', quality);
			};
		};

		reader.onerror = reject;
	});
}

function getImageSize(url: string) {
	return new Promise<{ width: number, height: number }>((resolve) => {
		const img = new Image();

		img.src = url;
		img.onload = () => {
			const { width, height } = img;

			resolve({ width, height })
		}
	});
}

export {
	convertFileToBase64,
	converArrayBufferToString,
	compressImage,
	getImageSize,
};
